import React, { useImperativeHandle } from "react";
import    { useState ,useEffect,useRef,forwardRef} from "react";
import qrcode from "../../src/images/qrcode.png";
import { SVGICON } from "../jsx/constant/theme";
import { useLocation,useNavigate } from 'react-router-dom';
import logo from '../jsx/components/Reports/food.jpg';
import { useReactToPrint } from "react-to-print";
import axios from "axios";
import { Modal } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Invoice = React.forwardRef((props, ref) => {
  const location = useLocation();const componentRef = useRef();
  const componentRef1 = useRef()
  const generatePDF = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Userdata",
    onAfterPrint: () => setInviteModal(false)
  });
  ;
  const generatePDF1 = useReactToPrint({
    content: () => componentRef1.current,
    documentTitle: "Userdata",
    onAfterPrint: () => alert("Data saved in PDF")
  });
  const searchParams = new URLSearchParams(location.search);

  const receivedDataArray = JSON.parse(searchParams.get('data')) || [];
  const receivedItemId = searchParams.get('id') || '';
  const DiscountAmount = searchParams.get('DiscountAmount') || '';
  const CustomerName = searchParams.get('name') || '';
  const lastdip = searchParams.get('TotalAmount') || '';
  const lastorder = searchParams.get('lastorder') || '';

  const [data3, setData3] = useState({});
  const [toolItems, settoolItems] = useState([]);

  const [orderItems, setOrderItems] = useState([]);
  const [TotalAmount, setTotalAmount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);

  const [Discount, setDiscount] = useState(0);
  const [Discount1, setDiscount1] = useState(0);
  const [report, setreport] = useState({})
  const userdata = localStorage.getItem('USER_data');
  const userData = JSON.parse(userdata);
    const userid = userData.id;
    
    const username = userData.name;
    const name = username.split('@')[0]; 
    const [order, setOrder] = useState({
      //  OrderID:'',
      CustomerID: '',
      OrderDate: '',
      TotalAmount: '',
      DiscountAmount: '',
      Status: '',
      UserID: userid,
      CustomerName: '',
      DeliveryPersonID: '',
      DeliveryDate: '',
      DeliveryTime: '',
      DelPrice: '',
      Address: '',
      GuaranteeTypesID: '',
      Prepay:'',
    });
  let sum = 0
  useEffect(() => {
    setOrderItems(props.data2);
    //settoolItems(props.data3)
    setOrder(props.data)
    settoolItems(props.data3)
    //const totalPrice = props.data2.reduce((sum, item) => sum +(item.Quantity*item.ItemPrice), 0);
  // cal();
   // EditData55(lastorder)
   // const totalAmounts = orderItems.map(item => item.TotalAmount);
    //console.log("totalAmounts", totalAmounts)
  //setTotalPrice(totalPrice)
        
  
    setTotalAmount(order.TotalAmount);
 
    setDiscount1(order.DiscountAmount);
    console.log(Discount1)
  }, [props.data, setOrder])
  console.log("newOrderItems", orderItems)
  
   // const intervalId = setInterval(() => {
    //   setOrderDate(new Date());
   //  }, 1000); // Update every 1000 milliseconds (1 second)
 
     // Cleanup function to clear the interval when the component unmounts
   //  return () => clearInterval(intervalId);
   const cal = () => {
    const totalAmounts = orderItems.map(item => item.TotalAmount);
    console.log("totalAmounts", totalAmounts)
  
        
  
    setTotalAmount(totalAmounts[0]);
    console.log(TotalAmount)

    setDiscount1(DiscountAmount);
    console.log(Discount1)

    //setDiscount((totalItemPrice-DiscountAmount)) ;
    //console.log(Discount)

  };
   const [company, setcompany] = useState([]);

  useEffect(() => {
  const companydata = localStorage.getItem('companies');
  if (companydata) {
    const parsedData = JSON.parse(companydata);
    const singleCompany = Array.isArray(parsedData) ? parsedData[0] : parsedData;
    setcompany(singleCompany); // Set state to a single object
  }
}, []);
   
  const EditData55 = async (id) => {
    console.log('idedit', id);

     const response = await axios.get(`https://suhba.education.com.ly/back/api/getdiposit/${lastorder}`);
    const depositData = response.data.Deposit;
       setData3(depositData)
    
 
      
    //setID(id); setInviteModal(true)
    //getfooditeming(e, id)
     
        const newObj = {
          amount: depositData.amount,
          CustomerName: CustomerName, 
          deposit_date: depositData.deposit_date, 
          reference_number: depositData.reference_number,
          deposits: depositData.deposits,
          reastAmount: (orderItems.TotalAmount - depositData.amount),
        };
   
    console.log('data3', newObj)

      setreport(newObj)
 
 
   // invite3.current.showInviteModal()
   // invite3.current.generatePDF();
  }
  const [inviteModal, setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
    showInviteModal() {
      setInviteModal(true);
    }
  }));
  console.log(orderItems)
  return (
    <Modal className="modal fade" id="exampleModal1" style={{height:'700px'}} size="l" show={inviteModal} onHide={() => setInviteModal(false)} centered>
    <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="card mt-3">
             
       <div className="card-body" ref={componentRef} dir="rtl" style={{ fontSize: "12px", lineHeight: "1.3" }}>
  
  <div className="row" style={{ marginBottom: "5px" }}>
    <div className="col-xl-12">
      <center>
        <img
          src={`https://suhba.education.com.ly/so7ba/public${company.ImageName}`}
          alt="Logo"
          style={{ height: "70px", width: "110px" }}
        />
      </center>

      <div className="shop-info">
        <h2 style={{ textAlign: "center", margin: "5px 0", fontSize: "16px" }}>
          {company.CompanyName}
        </h2>
      </div>
    </div>
  </div>

  <div className="table-responsive">
    
    {/* معلومات العميل */}
    <table className="table table-bordered table-sm" style={{ marginBottom: "2px" }}>
      <tbody>
        <tr>
          <td style={{ padding: "4px" }}>الزبون: {order.CustomerName}</td>
          <td style={{ padding: "4px" }}>
            الهاتف: {order.PhoneNumber}-{order.PhoneNumber1}-{order.PhoneNumber2}
          </td>
        </tr>

        <tr>
          <td style={{ padding: "4px" }}>التاريخ: {order.OrderDate}</td>
          <td style={{ padding: "4px" }}>تاريخ التسليم: {order.DeliveryDate}</td>
        </tr>

        <tr>
          <td style={{ padding: "4px" }}>نوع الفاتورة: نهائية</td>
          <td style={{ padding: "4px" }}>الصالة: {order.HallName}</td>
        </tr>
      </tbody>
    </table>

    {/* جدول الأصناف */}
    <table className="table table-bordered table-sm" style={{ marginBottom: "2px" }}>
      <thead>
        <tr>
          <th style={{ padding: "4px" }}>#</th>
          <th style={{ padding: "4px" }}>الصنف</th>
          <th style={{ padding: "4px" }}>سعر القطعة</th>
          <th style={{ padding: "4px" }}>الكمية</th>
          <th style={{ padding: "4px" }}>المجموع</th>
        </tr>
      </thead>

      <tbody>
        {orderItems.map((item, ind) => (
          <tr key={ind}>
            <td style={{ padding: "4px" }}>{ind}</td>
            <td style={{ padding: "4px" }}>{item.Name}</td>
            <td style={{ padding: "4px" }}>{item.ItemPrice}</td>
            <td style={{ padding: "4px" }}>{item.Quantity}</td>
            <td style={{ padding: "4px" }}>{item.Quantity * item.ItemPrice} د</td>
          </tr>
        ))}

        {toolItems.map((item, ind) => (
          <tr key={ind}>
            <td style={{ padding: "4px" }}>{ind}</td>
            <td style={{ padding: "4px" }}>{item.TName}</td>
            <td style={{ padding: "4px" }}>{item.TItemPrice}</td>
            <td style={{ padding: "4px" }}>{item.Quantity}</td>
            <td style={{ padding: "4px" }}>{item.Quantity * item.TItemPrice} د</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* الحسابات */}
  <div className="row" style={{ marginTop: "5px" }}>
    <div className="col-lg-12 col-sm-5">

      <table className="table table-sm" style={{ float: "right" }}>
        <tbody>

          <tr>
            <td style={{ padding: "4px" }}><strong>سعر التزين</strong></td>
            <td style={{ padding: "4px" }}><strong>{order.DecoratePrice}</strong></td>
            <td style={{ padding: "4px" }}><strong>عدد الصحون</strong></td>
            <td style={{ padding: "4px" }}>
              <strong>{(Number(order.DecoratePrice) / order.tabakprice).toFixed(2)}</strong>
            </td>
          </tr>

          <tr>
            <td style={{ padding: "4px" }}><strong>سعر التوصيل</strong></td>
            <td style={{ padding: "4px" }}><strong>{order.DelPrice}</strong></td>
          </tr>

          <tr>
            <td style={{ padding: "4px" }}><strong>التخفيض</strong></td>
            <td style={{ padding: "4px" }}>{order.DiscountAmount}</td>
          </tr>

          <tr>
            <td style={{ padding: "4px" }}><strong>الصافي</strong></td>
            <td style={{ padding: "4px" }}><strong>{order.TotalAmount}</strong></td>
          </tr>

          <tr>
            <td style={{ padding: "4px" }}><strong>العربون</strong></td>
            <td style={{ padding: "4px" }}><strong>{order.Prepay}</strong></td>
          </tr>

          <tr>
            <td style={{ padding: "4px" }}><strong>الباقي</strong></td>
            <td style={{ padding: "4px" }}>
              <strong>{order.TotalAmount - order.amounts}</strong>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>

  {/* الملاحظات */}
  <div className="col-xl-12">
    <p style={{ color: "gray", fontWeight: "bold", lineHeight: "1.5", fontSize: "11px" }}>
      ملاحظة:<br />
      - نظرًا للتقلبات في أسعار المواد الخام، قد تطرأ تغييرات على الأسعار،
      وسيتم إبلاغكم قبل موعد المناسبة بمدة لا تقل عن (10) أيام.
      <br />
      - تُعاد المعدات خلال (24) ساعة من تاريخ الاستلام،
      وفي حال التأخير سيتم فرض رسوم إضافية.
    </p>

    <p style={{ marginTop: "5px", fontSize: "11px" }}>
      <strong>إعداد بواسطة:</strong> {order.UserName?.split('@')[0] || ''}
    </p>

    <center>
      <p style={{ marginTop: "10px", fontSize: "11px" }}>الختم</p>
    </center>
  </div>

</div>
          
         <div className="modal-footer">
            <button  className="btn btn-primary m-2" onClick={generatePDF}>طباعه الفاتورة</button>
 
          </div> </div>  </div>
          
        </div>
      </div>
   
    </Modal>
  );
});

export default Invoice;
